export default __webpack_public_path__ + "static/bmu-b3b6aa2e47365e1e2467ec02371cd07e.jpg";